/**
 * Search for Artist Guitars.
 *
 * @since 2021-15-07
 * @package PD\ArtistGuitars
 */

/* global instantsearch algoliasearch */
'use strict';

let products = instantsearch(
	{
		indexName: 'shopify_agukproducts',
		searchClient: algoliasearch( 'LGZIJ6N7V1', 'f9738cc4d26029302839fd7195cf394f' ), /* Application ID and Search-Only API Key */
		routing: true,
		searchFunction: function ( helper ) {
			if ( helper.state.query === '' ) {
				$( ".pd-search-results" ).hide();
				window.scrollTo( 0, 0 );
				$( "body" ).removeClass( "pd-search-open" );
				$( ".section-header-search" ).removeClass( "show" );
				return;
			} else {
				$( ".pd-search-results" ).show();
				window.scrollTo( 0, 0 );
				$( "body" ).addClass( "pd-search-open" );
				$( ".section-header-search" ).addClass( "show" );
			}
			helper.search();
		}
	}
);

let mainSearchboxTimeout;
let mainSearchbox = instantsearch.connectors.connectSearchBox(
	function (
		renderOptions,
		isFirstRender
	) {
		let widgetParams = renderOptions.widgetParams;

		if ( isFirstRender ) {
			/* Search Input HTML target ID=#searchbox */
			document.querySelector( widgetParams.container ).innerHTML =
				'<div class="input-group">' +
				'<input class="form-control" value="' + getParameterByName( 'query' ) + '" placeholder="' + widgetParams.placeholder + '" id="pd-main-search-input" aria-label="Input search"/>' +
				'<div class="input-group-append">' +
				'<button class="btn btn-outline-secondary" aria-label="Search Button"><i class="fa fa-search" aria-hidden="true"></i></button>' +
				'</div>' +
				'</div>';
			document.querySelector( '#pd-main-search-input' ).addEventListener(
				'input',
				function ( event ) {
					clearTimeout( mainSearchboxTimeout );
					mainSearchboxTimeout = window.setTimeout( function () {
						renderOptions.refine( event.target.value );
					}, 1000 );
				}
			);
		}
	}
);

var facetTemplateCheckbox = '<a {{#isRefined}}data-insights-filter="category:{{value}}"{{/isRefined}} class="filter{{#isRefined}}-remove{{/isRefined}} filter text-dark list-group-item list-group-item-action d-flex justify-content-between align-items-center search-categories" href="" rel="nofollow" onClick="aa(\'clickedFilters\', {eventName: \'Category Filter Clicked\', index: \'pd-categories\', filters: [ \'category:{{value}}\' ]});{{#isRefined}}dataLayer.push({ event: \'Filters Viewed\' });{{/isRefined}}">' +
	'<span>{{^isRefined}}<i class="far fa-square"></i>{{/isRefined}}{{#isRefined}}<i class="fa fa-check-square"></i>{{/isRefined}} {{label}}</span>' +
	'<span class="badge badge-secondary badge-pill">{{count}}</span>' +
	'</a>';

var facetTemplateCheckboxBrand = '<a {{#isRefined}}data-insights-filter="brand:{{value}}"{{/isRefined}} class="filter{{#isRefined}}-remove{{/isRefined}} filter text-dark list-group-item list-group-item-action d-flex justify-content-between align-items-center search-brands" href="" rel="nofollow" onClick="aa(\'clickedFilters\', {eventName: \'Brand Filter Clicked\', index: \'pd-brands\', filters: [ \'brand:{{value}}\' ]});{{#isRefined}}dataLayer.push({ event: \'Filters Viewed\' });{{/isRefined}}">' +
	'<span>{{^isRefined}}<i class="far fa-square"></i>{{/isRefined}}{{#isRefined}}<i class="fa fa-check-square"></i>{{/isRefined}} {{label}}</span>' +
	'<span class="badge badge-secondary badge-pill">{{count}}</span>' +
	'</a>';

let categoryList = instantsearch.widgets.panel(
	{
		templates: {
			header: '<div class="list-group-item filter-title"><h3 class="h4 mb-0">Category</h3></div>',
			collapseButtonText( options ) {
				return '';
			},
		},
		hidden( options ) {
			return options.results.nbHits === 0;
		},
		collapsed: ( { state } ) => {
			return state.query.length === 0;
		},
		cssClasses: {
			header: 'position-relative',
		},
	}
)( instantsearch.widgets.hierarchicalMenu );

let brandList = instantsearch.widgets.panel(
	{
		templates: {
			header: '<div class="list-group-item filter-title"><h3 class="h4 mb-0">Brands</h3></div>',
			collapseButtonText( options ) {
				return '';
			},
		},
		hidden( { results } ) {
			return results.getFacetValues( 'vendor' ).length === 0;
		},
		collapsed: ( { state } ) => {
			return state.query.length === 0;
		},
		cssClasses: {
			header: 'position-relative',
		},
	}
)( instantsearch.widgets.refinementList );

let algoliaList = instantsearch.widgets.panel(
	{
		templates: {
			header: '<span></span>',
			collapseButtonText( options ) {
				return '';
			},
		},
		hidden( { results } ) {
			return false;
		},
		collapsed: ( { state } ) => {
			return false;
		},
	}
)( instantsearch.widgets.refinementList );

let priceInput = instantsearch.widgets.panel(
	{
		templates: {
			header: '<div class="list-group-item"><h3 class="h4 mb-0">Price Range</h3></div>',
		},
	}
)( instantsearch.widgets.rangeSlider );

products.addWidgets( [
	instantsearch.widgets.configure( {
		hitsPerPage: 20,
		filters: 'inventory_quantity!=999 AND price>0',
		analytics: true,
		clickAnalytics: true,
	} ),
	mainSearchbox( {
		container: '#pd-main-searchbox',
		placeholder: 'Search our store...',
	} ),
	instantsearch.widgets.sortBy( {
		container: '#pd-sort-by',
		items: [
			{ value: 'shopify_agukproducts', label: 'Most Popular' }
		],
		cssClasses: {
			root: '',
			select: 'form-control',
		},
		label: 'sort by',
	} ),
	instantsearch.widgets.stats( {
		container: '#pd-stats',
		templates: {
			text: '{{#hasNoResults}}No results{{/hasNoResults}}' +
				'{{#hasOneResult}}1 Product Found{{/hasOneResult}}' +
				'{{#hasManyResults}}<strong>{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}</strong> Products Found{{/hasManyResults}}',
		},
	} ),
	instantsearch.widgets.clearRefinements( {
		container: '#pd-clear-refinements',
		templates: {
			resetLabel: 'Clear Filters',
		},
		cssClasses: {
			root: '',
			button: 'btn btn-outline-secondary',
		},
	} ),
	categoryList( {
		container: '#pd-categories',
		attributes: [
			'product_type'
		],
		sortBy: [ 'isRefined', 'name:asc' ],
		searchable: false,
		showMore: false,
		templates: {
			item: facetTemplateCheckbox,
		},
		cssClasses: {
			root: '',
			list: 'list-group',
			item: 'filter',
		},
	} ),
	brandList( {
		container: '#pd-brands',
		attribute: 'vendor',
		operator: 'or',
		searchable: false,
		showMore: false,
		templates: {
			item: facetTemplateCheckboxBrand,
		},
		cssClasses: {
			root: '',
			list: 'list-group',
			item: 'filter',
		},
	} ),
	priceInput( {
		container: '#pd-price',
		attribute: 'price',
		tooltips: {
			format: function ( rawValue ) {
				return '$' + Math.round( rawValue ).toLocaleString();
			}
		},
	} ),
	instantsearch.widgets.pagination( {
		container: '#pd-pagination',
		showFirst: false,
		showLast: false,
		padding: 2,
		cssClasses: {
			root: 'wrap-pagination-bg text-center',
			list: 'pagination justify-content-center',
			selectedItem: 'active',
			item: 'page-item',
			link: 'page-link',
		},
	} ),
	instantsearch.widgets.hits( {
		container: '#pd-results',
		templates: {

			item( hit, bindEvent ) {
				moment.locale( 'en' );
				//console.log(hit);
				let user_id        = get_user_id();
				let price_html     = '';
				let sale_html      = '';
				let stock_html     = '';
				let behidden = '';

				if ( ( hit.compare_at_price > hit.price ) ) {
					price_html = '<span class="was-price">' + formatCurrency( hit.compare_at_price, "£" ) + '</span>' +
						'<span itemprop="price" class="price-now" content="' + hit.price + '">' + formatCurrency( hit.price, "£" ) + '</span>';
				} else if ( hit.product_type.includes( "Damaged & Customer Returned" ) ) {
					if (  hit.title.includes( "Damaged" )  ) {
						price_html = '<span class="badge badge-warning mb-1">Damaged</span><br>';
					} else {
						price_html = '<span class="badge badge-warning mb-1">Customer Returned</span><br>';
					}
					price_html = price_html + '<span itemprop="price" class="price-now" content="' + hit.price + '">' + formatCurrency( hit.price, "£" ) + '</span>';
				} else {
					price_html = '<span itemprop="price" class="price-now" content="' + hit.price + '">' + formatCurrency( hit.price, "£" ) + '</span>';
				}

                let new_preorder_quantity = 0;

                try{
                  new_preorder_quantity = hit.meta.misc.PreorderQuantity;
                } catch(e) {}
                
				console.log(new_preorder_quantity);
				if ( hit.sku == 18758 || hit.sku == 18759 || hit.sku == 18760 || hit.sku == 18761 || hit.sku == 19016 || hit.sku ==  18602 || hit.sku ==  18900 || hit.sku ==  19400 || hit.sku ==  18827 || hit.sku ==  18603 || hit.sku ==  17997 || hit.sku ==  19723 || hit.sku ==  19724 || hit.sku ==  70685 || hit.sku ==  70684 ){
                    behidden = 'd-none';
                }
              
				if ( ( hit.inventory_quantity < 1 ) && ( hit.inventory_available == true ) && ( new_preorder_quantity > 0 ) ) {
                    let arrival_date   = moment( hit.meta.misc.PreorderDate ).add( 1, 'days' ).tz( "Europe/London" ).format( "MMM Do" );
					stock_html = '<div class="thumb-stock stock-pre-order">Pre-order&nbsp;<span class="float-right ' + behidden + '">&nbsp;Due ' + arrival_date + '</span></div>';
					if ( hit.sku == 18758 || hit.sku == 18759 || hit.sku == 18760 || hit.sku == 18761 || hit.sku == 19016 || hit.sku ==  18602 || hit.sku ==  18900 || hit.sku ==  19400 || hit.sku ==  18827 || hit.sku ==  18603 || hit.sku ==  17997 || hit.sku ==  19723 || hit.sku ==  19724 || hit.sku ==  70685 || hit.sku ==  70684){
					    stock_html = '<div class="thumb-stock stock-pre-order">Special Order Only</div>';
					}
				} else if ( hit.inventory_quantity > 0 || hit.title.includes( "Artist Guitars Gift Card" ) ) {
					stock_html = '<div class="thumb-stock stock-in-stock">In Stock</div>';
				} else {
                    let delivery_date = "na";
                    try{
                      delivery_date = hit.meta.misc.AvailabilityDescription;
                    } catch(e) {}
                    let approxdate = "";
                      if(delivery_date != "na"){
                        let n = delivery_date.split(" ");
                        let l = n[n.length - 1].substring(0,3);
                        approxdate = '&nbsp;<span class="float-right">&nbsp;Approx ' + l + '</span>';
                      }
					stock_html = '<div class="thumb-stock stock-sold">Out of Stock' + approxdate + '</div>';
				}

				if ( hit.compare_at_price > hit.price ) {
					sale_html = '<span class="badge badge-danger">On Sale</span>';
				} else if ( ( hit.inventory_quantity < 1 ) && (hit.sku == 18758 || hit.sku == 18759 || hit.sku == 18760 || hit.sku == 18761 || hit.sku == 19016 || hit.sku ==  18602 || hit.sku ==  18900 || hit.sku ==  19400 || hit.sku ==  18827 || hit.sku ==  18603 || hit.sku ==  17997 || hit.sku ==  19723 || hit.sku ==  19724 || hit.sku ==  70685 || hit.sku ==  70684) ){
				    sale_html = '<span class="badge badge-warning">Special Order Only</span>';
				}
				
				
				return '<div data-insights-object-id="' + hit.objectID + '" data-insights-position="' + hit.__position + '" data-insights-query-id="' + hit.__queryID +'" class="card thumbnail card-body">' +
					'<meta itemprop="brand" content="' + hit.vendor + '"/>' +
					'<meta itemprop="mpn" content="' + hit.sku + '"/>' +
					'<a href="/products/' + hit.handle + '" class="thumbnail-image" onClick="localStorage.setItem(\'algoliaQueryID\', \'' + hit.__queryID +'\');localStorage.setItem(\'algoliaObjectID\', \'' + hit.objectID +'\');" >' +
					'<img src="' + hit.image + '" itemprop="image" class="product-image img-fluid" alt="' + hit.title + '" title="' + hit.title + '" rel="itmimg' + hit.sku + '" onerror="check_img(this)">' +
					'</a>' +
					'<div class="thumbnail-box">' +
					'<div class="thumb-availability">' +
					stock_html +
					'</div>' +
					'<p class="card-title" itemprop="name"><a href="/products/' + hit.handle + '" onClick="localStorage.setItem(\'algoliaQueryID\', \'' + hit.__queryID +'\');localStorage.setItem(\'algoliaObjectID\', \'' + hit.objectID +'\');" >' + hit.title + '</a></p>' +
					'<p class="price" itemprop="offers" itemscope itemtype="http://schema.org/Offer" aria-label="' + hit.title + ' price">' +
					price_html +
					'<meta itemprop="priceCurrency" content="GBP">' +
					'</p>' +
					'<div class="savings-container">' +
					sale_html +
					'</div>' +
					'</div>' +
					'</div>';
                
			},
			empty: '<div class="pd-empty-results">Sorry, we don'+"'"+'t have that model.<br>Please feel free to contact us at <a href="mailto:sales@artistguitars.co.uk">sales@artistguitars.co.uk</a> for advice on similar models.</div>',
		},
		cssClasses: {
			item: 'col-6 col-sm-6 col-lg-4 col-xl-3 article',
			list: 'row products-row',
		},
	} ),
	instantsearch.widgets.clearRefinements( {
		container: '#closeAlgolia',
		includedAttributes: [ 'query', 'product_type', 'vendor' ],
		templates: {
			resetLabel: ''
		},
		cssClasses: {
			button: [ 'npopup-btn-close d-lg-none' ]
		}
	}),
	algoliaList( {
		container: '#pd-algolia',
		attribute: 'has_child',
		templates: {
			item: function(){
                var username = document.getElementById('username').innerHTML;
                var setUserToken = '';
                var substring = "nloader-content-id";

                if(username == 'noreg' || username.indexOf(substring) !== -1){
                    
                aa('getUserToken', null, (err, userToken) => {
                  dataLayer.push({
                      algoliaUserToken: userToken,
                    });
                    localStorage.setItem('algoliaUserToken', userToken);
                })
                
                }else{
                    aa('setUserToken', username);
                    dataLayer.push({algoliaUserToken: username,});
                    localStorage.setItem('algoliaUserToken', username);
                }
			    dataLayer.push({ event: 'Hits Viewed' });
			}
		},
	} )
] );

products.start();

function getParameterByName( name ) {
	name        = name.replace( /[\[]/, "\\\[" ).replace( /[\]]/, "\\\]" );
	var regexS  = "[\\?&]" + name + "=([^&#]*)";
	var regex   = new RegExp( regexS );
	var results = regex.exec( window.location.search );
	if ( results == null )
		return "";
	else
		return decodeURIComponent( results[ 1 ].replace( /\+/g, " " ) );
}

function check_img( source ) {
	source.src     = 'https://cdn.neto.com.au/assets/neto-cdn/images/default_product.gif';
	source.onerror = '';
	return true;
}

function formatCurrency( val, currency ) {
	return currency + parseFloat( val ).toFixed( 2 ).replace( /(\d)(?=(\d{3})+\.)/g, '$1,' );
}

function searchClick() {
	if ( $( '#pd-main-search-input' ).val() == "" ) {
		window.location.replace( window.location.origin + '?rf=kw&kw=' );
	} else {
		window.location.replace( window.location.origin + '?rf=kw&kw=' + encodeURI( $( '#pd-main-search-input' ).val() ) );
	}
}

function closeAlgolia() {
	$( ".pd-search-results" ).hide();
	$( "body" ).removeClass( "pd-search-open" );
	$( ".section-header-search" ).removeClass( "show" );
}

$( document ).click( function ( e ) {
	var search_box = $( "#pd-main-searchbox" );
	var container  = $( ".pd-search-results .row" );
	var mobile     = $( "#pd-mobile-searchbox" );
	
	if ( ! search_box.is( e.target ) && search_box.has( e.target ).length === 0 && ! container.is( e.target ) && container.has( e.target ).length === 0 && ! mobile.is( e.target ) && mobile.has( e.target ).length === 0 ) {
		$( ".ais-ClearRefinements-button.npopup-btn-close" ).click();
		$( "#pd-main-search-input" ).val( '' );
		$( "#pd-mobile-search-input" ).val( '' );
	}
} );

/**
 * Gets the current user ID.
 *
 * @returns {int|null} The user ID or null if unable to (should not happen).
 */

function get_user_id() {
    var theuser = "";
    if (typeof neto_user_id !== 'undefined') {
      theuser = parseInt(neto_user_id);
    }else{
      theuser = null;
    }
	return theuser;
}

/**
 * Gets the price for the current user.
 *
 * @param {object} product The product with the price groups.
 *
 * @returns {string|null} The price for the current user. Null on error.
 */


function get_user_price( product ) {
	// Get the current user ID.
	var user_id = get_user_id(); // Init empty price group for later.

	var price_group = null; // Get the price groups from the product.

	if ( product.hasOwnProperty( 'price_groups' ) ) {
		var _price_groups = product.price_groups;
	} else {
		return null;
	} // Go through each group until we have the desired group.


	for ( var i = 1; i < Object.keys( price_groups ).length; i ++ ) {
		if ( price_groups[ i ].id === user_id ) {
			price_group = price_groups[ i ];
			break;
		}
	} // Return the price if it's set.


	return price_group ? price_group.price : null;
}

